import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=cf2396fa&scoped=true"
import script from "./bulk.vue?vue&type=script&lang=js"
export * from "./bulk.vue?vue&type=script&lang=js"
import style0 from "./bulk.vue?vue&type=style&index=0&id=cf2396fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2396fa",
  null
  
)

export default component.exports